export const kpis = [
  { label: 'Monthly recurring revenue', value: '$428.6K', change: '+18.4%', tone: 'positive', spark: [42,47,45,52,58,61,67,73,78,84,88,96] },
  { label: 'Active workspaces', value: '12,842', change: '+9.7%', tone: 'positive', spark: [52,54,58,57,61,64,66,70,74,77,80,84] },
  { label: 'Net revenue retention', value: '121.8%', change: '+3.2%', tone: 'positive', spark: [60,62,63,65,64,68,70,73,74,77,78,82] },
  { label: 'Infra cost / request', value: '$0.0042', change: '-11.6%', tone: 'positive', spark: [88,86,82,80,75,73,69,66,63,60,56,53] },
] as const;

export const revenue = [
  { month: 'Jan', value: 198 }, { month: 'Feb', value: 214 }, { month: 'Mar', value: 241 },
  { month: 'Apr', value: 226 }, { month: 'May', value: 267 }, { month: 'Jun', value: 289 },
  { month: 'Jul', value: 311 }, { month: 'Aug', value: 346 }, { month: 'Sep', value: 429 },
];

export const projects = [
  { name: 'Atlas Command', owner: 'Core', status: 'Production', health: 98, deploys: 41, updated: '3 min ago' },
  { name: 'Northstar AI', owner: 'Labs', status: 'Production', health: 94, deploys: 29, updated: '12 min ago' },
  { name: 'Beacon Mobile', owner: 'Product', status: 'Staging', health: 87, deploys: 18, updated: '36 min ago' },
  { name: 'Signal Graph', owner: 'Data', status: 'Production', health: 99, deploys: 64, updated: '1 hr ago' },
  { name: 'Prism Billing', owner: 'Finance', status: 'Review', health: 91, deploys: 11, updated: '2 hr ago' },
  { name: 'Mercury Edge', owner: 'Infra', status: 'Production', health: 96, deploys: 53, updated: '4 hr ago' },
];

export const activity = [
  { actor: 'Avery Stone', action: 'deployed', target: 'Atlas Command', time: '3m', type: 'deploy' },
  { actor: 'Mina Park', action: 'approved', target: 'Design System v2', time: '11m', type: 'approve' },
  { actor: 'Noah Chen', action: 'commented on', target: 'Billing migration', time: '18m', type: 'comment' },
  { actor: 'Priya Shah', action: 'created', target: 'Q4 Growth Experiment', time: '29m', type: 'create' },
  { actor: 'Eli Brooks', action: 'resolved', target: 'API latency incident', time: '47m', type: 'resolve' },
];

export const messages = [
  { sender: 'Priya Shah', subject: 'Q4 launch readiness', preview: 'The rollout checklist is green except for one analytics dependency…', time: '9:42', unread: true, label: 'Product' },
  { sender: 'Mina Park', subject: 'Design system review', preview: 'I pushed the component audit and the accessibility pass results…', time: '8:17', unread: true, label: 'Design' },
  { sender: 'Eli Brooks', subject: 'Edge latency follow-up', preview: 'P95 is back under target across all regions after the cache policy change…', time: 'Yesterday', unread: false, label: 'Infra' },
  { sender: 'Noah Chen', subject: 'Experiment cohort export', preview: 'Attached the cleaned cohort summary and retention breakdown…', time: 'Yesterday', unread: false, label: 'Data' },
  { sender: 'Avery Stone', subject: 'Release train 46', preview: 'All production gates passed. We can advance the canary window…', time: 'Mon', unread: false, label: 'Release' },
];

export const team = [
  { name: 'Avery Stone', role: 'VP Engineering', team: 'Core Platform', status: 'Online', load: 72 },
  { name: 'Mina Park', role: 'Design Lead', team: 'Product Design', status: 'Online', load: 58 },
  { name: 'Noah Chen', role: 'Data Engineer', team: 'Data Systems', status: 'Focus', load: 81 },
  { name: 'Priya Shah', role: 'Product Manager', team: 'Growth', status: 'Online', load: 63 },
  { name: 'Eli Brooks', role: 'SRE', team: 'Infrastructure', status: 'On-call', load: 88 },
  { name: 'Sofia Reyes', role: 'Frontend Engineer', team: 'Experience', status: 'Offline', load: 44 },
];
